import { AlertCircle, LoaderCircle } from "lucide-react";
import type { ReactNode } from "react";
import { useAuth } from "../features/auth/AuthProvider";
import { LoginPage } from "../features/auth/LoginPage";
import { useI18n } from "../i18n";
import type { TranslateFn } from "../i18n";

function connectionMessage(error: Error, t: TranslateFn): string {
  if (/failed to fetch|networkerror|load failed/i.test(error.message)) {
    return t("auth.gate.offline");
  }
  return error.message || t("auth.gate.unreachable");
}

export function AuthGate({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const { t } = useI18n();
  if (auth.loading) {
    return <main className="full-page-state"><LoaderCircle className="spin" size={28} /><strong>{t("auth.gate.checking")}</strong><span>{t("auth.gate.pleaseWait")}</span></main>;
  }
  if (auth.error) {
    return (
      <main className="full-page-state error">
        <AlertCircle size={30} />
        <strong>{t("auth.gate.unreachableTitle")}</strong>
        <span>{connectionMessage(auth.error, t)}</span>
        <button className="secondary-button" type="button" onClick={() => void auth.refresh()}>{t("auth.gate.reconnect")}</button>
      </main>
    );
  }
  if (!auth.authenticated) return <LoginPage />;
  return children;
}
